import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const SortAscIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path d="M0 0H16V16H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M14.6034 2H5V4.39661H14.6034V2ZM16 6.80169H7.11096V9.19831H16V6.80169ZM13.4008 11.5949H5V14H13.4008V11.5949Z"
          fill={props.fill ? props.fill : "white"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.08037 7.99998C2.30129 7.99998 2.48037 8.17907 2.48037 8.39998V11.6C2.48037 11.8209 2.65946 12 2.88037 12H3.1196C3.34052 12 3.5196 11.8209 3.5196 11.6V8.39998C3.5196 8.17907 3.69869 7.99998 3.9196 7.99998H5.29351C5.60443 7.99998 5.79648 7.66079 5.63651 7.39418L3.34299 3.57164C3.18762 3.31271 2.81235 3.31271 2.65699 3.57164L0.363468 7.39418C0.203502 7.66079 0.395547 7.99998 0.706465 7.99998H2.08037Z"
          fill={props.fill ? props.fill : "white"}
        />
      </g>
    </SvgIcon>
  );
});
